import { faGripVertical } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Paper, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import { Message } from '../types'

const useStyles = makeStyles((theme) => ({
  noOverflow: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    '-webkit-box-orient': 'vertical',
    '-webkit-line-clamp': 1,
  },
  reorderItemContainer: {
    display: 'flex',
    flexGrow: 1,
    overflow: 'hidden',
    padding: theme.spacing(1, 2),
    gap: theme.spacing(2),
  },
}))

export const ReorderListItem = ({ message }: { message: Message }) => {
  const classes = useStyles()
  const stripDescription = () => {
    const desc = new DOMParser().parseFromString(message.Message, 'text/html')
    return desc.body.textContent || ''
  }
  return (
    <Paper className={classes.reorderItemContainer}>
      <Box
        display="flex"
        flexDirection="column"
        flex={1}
      >
        <Typography
          color="textPrimary"
          className={classes.noOverflow}
        >
          {message.Subject}
        </Typography>
        <Typography
          color="textSecondary"
          variant="body2"
          className={classes.noOverflow}
        >
          {stripDescription()}
        </Typography>
      </Box>
      <Box
        display="flex"
        alignItems="center"
        color="text.disabled"
      >
        <FontAwesomeIcon
          icon={faGripVertical}
          size="lg"
        />
      </Box>
    </Paper>
  )
}
